import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";

import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { es } from "date-fns/locale";

// estilos
import "../../assets/style/componentPrincipal.css";
//import './pptos.css'
import "./pptosNew.css";

import "../../assets/style/tablesG.css";

// componentes
import { Buscar } from "../general/buscadorNegocios/Buscar";
/* import { Crear } from "../general/crear/Crear";
import { ExportExcelNegocios } from "../general/exportarPlanilla/ExportExcelNegocios"; */

/* import { usePptos } from "../../hooks/usePptos"; */

// redux
import { iniCargarNegocios } from "../../redux/actions/pptos";
/* import { VerReporte } from "../general/verReporte/VerReporte"; */
// import { TableListAprobados } from '../tables/TableListAprobados'
import { TableListAprobadoPorFacturar } from "../tables/TableListAprobadosPorFacturar";
import { Tooltip } from "@mui/material";
import { SlidersHorizontal } from "lucide-react";

export const PptosListaAprobadosPorFacturar = () => {
  /* const { initExportNegocios } = usePptos(); */
  const filtersDefaultDate = useSelector((state) => state.ppto.ppto_filters);
  const [showFilters, setShowFilters] = useState(false);

  const dispatch = useDispatch();
  const [filters, setFilters] = useState({
    time: filtersDefaultDate?.time || "all",
    estado: "aprobado",
    check_proceso: true,
    check_standby: false,
    check_cerrada: false,
    text: "",
    fecha_desde: filtersDefaultDate?.fecha_desde || new Date(),
    fecha_hasta: filtersDefaultDate?.fecha_hasta || new Date(),
    abierto_compras: false,
    cerrado_compras: false,
    facturado: false,
    por_facturar: true,
    id_unit: "",
    id_ejecutivo: "",
    page: 1,
    rows: 10,
  });

  const handleChangeDateDesde = (newValue) => {
    setFilters({
      ...filters,
      fecha_desde: newValue,
    });
  };

  const handleChangeDateHasta = (newValue) => {
    // console.log(newValue)
    setFilters({
      ...filters,
      fecha_hasta: newValue,
    });
  };

  useEffect(() => {
    dispatch(iniCargarNegocios(filters));
  }, [dispatch, filters]);

  return (
    <div className="p-container">
      <h1 className="p-title flex items-center gap-2">
        <span>Proyectos por facturar</span>
        <Tooltip title="Mostrar opciones de búsqueda">
          <button onClick={() => setShowFilters(!showFilters)}>
            <SlidersHorizontal className="w-4 h-4 mt-1" />
          </button>
        </Tooltip>
      </h1>

      {showFilters && (
        <>
          <DateFilters
            filters={filters}
            setFilters={setFilters}
            handleChangeDateDesde={handleChangeDateDesde}
            handleChangeDateHasta={handleChangeDateHasta}
          />

          <div className="row p-box-searching">
            <div className="col d-flex">
              <Buscar filters={filters} setFilters={setFilters} />
              {/* <div className="p-box-crear">
            <Crear />
          </div> */}
            </div>
            {/* <div className="col d-flex justify-content-end">
          <ExportExcelNegocios
            filters={filters}
            initExport={initExportNegocios}
          />
          <VerReporte />
        </div> */}
          </div>
        </>
      )}

      <div className="row p-box-filters">
        <div className="col p-box-filters-items">
          <Link to="/ppto">Presupuestos por aprobar</Link>
          <Link to="/projects">Proyectos aprobados</Link>
          <Link to="/projects/pf" className="selected">
            Pendientes por facturar
          </Link>
        </div>
      </div>

      <TableListAprobadoPorFacturar filters={filters} setFilters={setFilters} />
    </div>
  );
};

const DateFilters = ({
  filters,
  setFilters,
  handleChangeDateDesde,
  handleChangeDateHasta,
}) => {
  return (
    <>
      <div className="row mt-3">
        <div className="col text-start">
          <div
            className="btn-group"
            role="group"
            aria-label="Basic radio toggle button group"
          >
            <input
              type="radio"
              className="btn-check"
              name="btnradio"
              id="btnradio1"
              autoComplete="off"
              checked={filters.time === "all" && "checked"}
              onChange={() => setFilters({ ...filters, time: "all" })}
            />
            <label
              className="btn btn-outline-light"
              htmlFor="btnradio1"
              style={{ color: filters.time === "all" ? "#8E24AA" : "#595759" }}
            >
              Todos en proceso
            </label>

            <input
              type="radio"
              className="btn-check"
              name="btnradio"
              id="btnradio2"
              autoComplete="off"
              checked={filters.time === "year" && "checked"}
              onChange={() => setFilters({ ...filters, time: "year" })}
            />
            <label
              className="btn btn-outline-light"
              htmlFor="btnradio2"
              style={{ color: filters.time === "year" ? "#8E24AA" : "#595759" }}
            >
              Anual ({moment(filters.fecha_desde).format("YYYY")})
            </label>

            <input
              type="radio"
              className="btn-check"
              name="btnradio"
              id="btnradio3"
              autoComplete="off"
              checked={filters.time === "month" && "checked"}
              onChange={() => setFilters({ ...filters, time: "month" })}
            />
            <label
              className="btn btn-outline-light"
              htmlFor="btnradio3"
              style={{
                color: filters.time === "month" ? "#8E24AA" : "#595759",
              }}
            >
              Mensual (
              <span style={{ textTransform: "capitalize" }}>
                {moment(filters.fecha_desde).format("MMMM")}
              </span>{" "}
              {moment(filters.fecha_desde).format("YYYY")})
            </label>

            <input
              type="radio"
              className="btn-check"
              name="btnradio"
              id="btnradio4"
              autoComplete="off"
              checked={filters.time === "range" && "checked"}
              onChange={() => setFilters({ ...filters, time: "range" })}
            />
            <label
              className="btn btn-outline-light"
              htmlFor="btnradio4"
              style={{
                color: filters.time === "range" ? "#8E24AA" : "#595759",
              }}
            >
              Rango
            </label>
          </div>
        </div>
      </div>

      {filters.time === "year" && (
        <div className="mt-4 p-text-date-year">
          <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
            <DatePicker
              views={["year"]}
              label="Año"
              openTo="year"
              name="fecha_desde"
              value={filters.fecha_desde}
              onChange={handleChangeDateDesde}
              renderInput={(params) => (
                <TextField {...params} helperText={null} />
              )}
            />
          </LocalizationProvider>
        </div>
      )}

      {filters.time === "month" && (
        <div className="mt-4 p-text-date-month">
          <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
            <DatePicker
              views={["year", "month"]}
              label="Mes"
              openTo="month"
              name="fecha_desde"
              // minDate={new Date('2020-01-01')}
              value={filters.fecha_desde}
              onChange={handleChangeDateDesde}
              renderInput={(params) => (
                <TextField {...params} helperText={null} />
              )}
            />
          </LocalizationProvider>
        </div>
      )}

      {filters.time === "range" && (
        <div className="row mt-4">
          <div className="col text-start d-flex justify-content-start p-text-date-range">
            <span>
              <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                <DatePicker
                  views={["year", "month"]}
                  label="Mes desde"
                  openTo="month"
                  name="fecha_desde"
                  // minDate={new Date('2020-01-01')}
                  value={filters.fecha_desde}
                  onChange={handleChangeDateDesde}
                  renderInput={(params) => (
                    <TextField {...params} helperText={null} />
                  )}
                />
              </LocalizationProvider>
            </span>
            <span style={{ marginLeft: "10px" }}>
              <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                <DatePicker
                  views={["year", "month"]}
                  label="Mes hasta"
                  openTo="month"
                  name="fecha_hasta"
                  // minDate={new Date('2020-01-01')}
                  value={filters.fecha_hasta}
                  onChange={handleChangeDateHasta}
                  renderInput={(params) => (
                    <TextField {...params} helperText={null} />
                  )}
                />
              </LocalizationProvider>
            </span>
          </div>
        </div>
      )}
    </>
  );
};
